export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9273.6d489852.jpg";